
import { Options, Vue } from 'vue-class-component';
import Game from '@/libs/home/Game';

@Options({
  components: {},
})
export default class Home extends Vue {
  mounted() {
    const game: Game = new Game();
  }
}
